module.exports = __webpack_public_path__ + "assets/booking-engine.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/booking-engine.png
// module id = 1135
// module chunks = 7